import getInventory from './getInventory';
import DrawModel from '@models/DrawModel';
import ProductModel from '@models/ProductModel';
import ProductDomainModel from '@models/ProductDomainModel';

export default async function (lotteryID, options = {}) {
  const query = {
    id: parseInt(lotteryID, 10),
    groupItems: options.groupItems || false,
    special: options.special || false
  };

  try {
    const response = await getInventory()

    if (!response || !response.portalDrawsOnSale || !response.productsOnSale) {
      return {
        nextDraw: null,
        products: null
      }
    }
    const nextDraw = response.portalDrawsOnSale
      .sort((a, b) => {
        return +(a.drawDate > b.drawDate) || +(a.drawDate === b.drawDate) - 1
      })
      .find((a) => {
        return a.lotteryID === query.id && a.isEspecial === query.special
      })
    if (!nextDraw) {
      return {
        nextDraw: null,
        products: null
      }
    }
    const lotteryProducts = response.productsOnSale.filter((a) => {
      return a.lotteryID === query.id && a.drawNumber === nextDraw.drawNumber
    })

    if (query.groupItems) {
      const productsDomains = {}
      lotteryProducts.forEach((a) => {
        a = new ProductModel(a)
        if (!productsDomains[a.domain]) {
          productsDomains[a.domain] = new ProductDomainModel({
            name: a.domain,
            lottery: a.lotteryID,
            badge: a.badge,
            unitPrice: a.unitPrice,
            moreChances: a.moreChances || null,
            units: a.units,
            items: [a]
          })
        } else if (
          !productsDomains[a.domain].items.find((b) => b.serie === a.serie)
        ) {
          productsDomains[a.domain].items.push(a)
        }
      })
      return {
        nextDraw: nextDraw ? new DrawModel(nextDraw) : null,
        products: Object.values(productsDomains).map((domain) => {
          domain.items = domain.items.sort((a, b) => a.serie - b.serie)
          return domain
        })
      }
    }

    return {
      nextDraw: nextDraw ? new DrawModel(nextDraw) : null,
      products: lotteryProducts.map((p) => new ProductModel(p))
    }
  } catch (err) {
    console.error(err)
    return new Error(err);
  }
}
